// extracted by mini-css-extract-plugin
export default {"carouselContainer":"NavHeader_carouselContainer__Eg0dn","photo":"NavHeader_photo__Z2QN1"};